import React, { useEffect, useState } from "react";
import { Container, Card, Button, Spinner, Image } from "react-bootstrap";
import { toast } from "react-toastify";

const CustomerAddonPage = () => {
  const projectVendorPaymentStructureId = new URLSearchParams(
    window.location.search
  ).get("ppid");

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const BASE_URL = process.env.REACT_APP_API_URL;

  // Fetch data when page loads
  useEffect(() => {
    if (!projectVendorPaymentStructureId) return;

    const fetchData = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/ProjectAdditionalItem/GetProjectAdditionalItemByProAddItemID_ByCustomer?ProjectAdditionalItemID=${projectVendorPaymentStructureId}`
        );

        if (!res.ok) throw new Error("Network error");

        const json = await res.json();
        setData(json);
      } catch (err) {
        toast.error("Failed to fetch data");
        console.error("Error fetching data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [projectVendorPaymentStructureId]);

  // Handle Accept/Reject button
  const handleAction = async (status) => {
    try {
      const res = await fetch(
        `${BASE_URL}/ProjectAdditionalItem/UpdateCustomerApprovalStatus`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ProjectAdditionalItemID: projectVendorPaymentStructureId,
            CustomerApprovalStatus: status, // 1 = Accept, 2 = Reject
          }),
        }
      );

      if (!res.ok) throw new Error("Failed to update status");
      const result = await res.json();

      if (result.IsSuccess) {
        toast.success(
          `Successfully ${status === 1 ? "Accepted" : "Rejected"}!`
        );
      } else {
        toast.error(result.Message || "Something went wrong");
      }
    } catch (err) {
      toast.error("Error updating status");
      console.error(err);
    }
  };

  if (loading) {
    return (
      <div className="d-flex vh-100 justify-content-center align-items-center bg-light">
        <Spinner animation="border" />
        <p className="ms-2">Loading...</p>
      </div>
    );
  }

  if (!data || !data.isSuccess) {
    return (
      <div className="d-flex vh-100 justify-content-center align-items-center bg-light">
        <h4>No Addon Data Found</h4>
      </div>
    );
  }

  return (
    <div className="vh-100 d-flex flex-column bg-light">
      {/* Header with Company Logo & Name */}
      <header className="bg-white shadow-sm p-3 d-flex align-items-center justify-content-center">
        <Image
          src="/Montdor_2.png" // 🔹 place your logo in public folder
          alt="Company Logo"
          height={50}
          className="me-3"
        />
        <h3 className="m-0 fw-bold text-dark">
          Montdor Interior
        </h3>
      </header>

      {/* Main Content */}
      <Container className="flex-grow-1 d-flex justify-content-center align-items-center">
        <Card className="shadow-lg p-4 w-100" style={{ maxWidth: "650px" }}>
          <Card.Body>
            <h4 className="text-center mb-4 text-dark fw-bold">
              Message from Company
            </h4>

            <Card.Title className="mb-2 text-primary text-center">
              {data.projectName} {data.projectNumber !== '' && `(${data.projectNumber})`}
            </Card.Title>
            <Card.Subtitle className="mb-3 text-muted text-center">
              Additional Work
            </Card.Subtitle>

            <Card.Text>
              <strong>Description:</strong> {data.additionalItemDescription}
            </Card.Text>
            <Card.Text>
              <strong>Amount:</strong> ₹{data.additionalAmount}
            </Card.Text>
            <Card.Text>
              <strong>Created On:</strong> {data.createDate || "-"}
            </Card.Text>

            {/* Accept / Reject Actions */}
            <div className="d-flex justify-content-between mt-4">
              <Button
                variant="success"
                className="px-4 w-50 me-2 fw-bold"
                onClick={() => handleAction(1)}
              >
                ✅ Accept
              </Button>
              <Button
                variant="danger"
                className="px-4 w-50 ms-2 fw-bold"
                onClick={() => handleAction(2)}
              >
                ❌ Reject
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>

      {/* Footer */}
      <footer className="bg-white text-center py-3 shadow-sm">
        <small className="text-muted">
          © {new Date().getFullYear()} Global Construction Solutions. All
          rights reserved.
        </small>
      </footer>
    </div>
  );
};

export default CustomerAddonPage;
